import axios from 'axios';
import { message } from 'antd';
import store from '../store';
import { logout } from '../store/modules/user/actions';

// 服务器地址
// eslint-disable-next-line
export const serverUrl = globalConfig.serverUrl;

let baseURL = '';
if (process.env.NODE_ENV === 'development') {
    baseURL = '/';
} else {
    baseURL = `${serverUrl}/`;
}

// 创建实例
const instance = axios.create();

// http request 拦截器，通过这个，我们就可以把Cookie传到后台
instance.interceptors.request.use(
    (config) => {
        if (config.params && config.params.noToken) {
            delete config.params.noToken;
        } else if (config.data && config.data.noToken) {
            delete config.data.noToken;
        } else {
            // config.headers.Authorization = 'bearer ' + localStorage.getItem('token');
            config.headers.Authorization = localStorage.getItem('token');
        }

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

/**
 * 服务端返回状态码
 * 200 成功
 * 1001 未知错误
 * 5001 用户名或密码错误
 * 5002 - 5006 Token验证失败
 */

/**
 * http response 拦截器 用户处理用户身份验证失败的情况
 */
instance.interceptors.response.use(
    (response) => {
        if ([5002, 5003, 5004, 5005, 5006].includes(response.data.code)) {
            let isLogin = false;
            const state = store.getState();
            if (state && state.user) {
                isLogin = state.user.isLogin;
            }

            // 防止登录失效后，因失效请求有多次，弹出多次未登录提示
            if (isLogin) {
                store.dispatch(logout());
            }

            return Promise.reject({
                noAlert: !isLogin,
                msg: '登录失效！请重新登录！'
            });
        }
        return response;
    },
    (error) => {
        return Promise.reject(error.response.data);
    }
);

/**
 * 用于处理 http 状态码，判断请求是否正常
 */
function checkStatus(response) {
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return checkCode(response.data);
    }

    // 异常状态下，把错误信息返回去
    if (!response.noAlert) {
        message.error(response.statusText || '网络异常！');
    }
    return Promise.reject({
        status: -404,
        msg: '网络异常！'
    });
}

/**
 * 用于处理服务端返回状态码
 */
function checkCode(res) {
    // code 为 200 则表示请求正常
    if (res && res.code === 200) {
        return res;
    }

    // 1001 为服务端抛出的未知错误
    // 如果不是未知错误，则把服务端返回的错误信息弹出
    if (res && res.code !== 1001) {
        message.error(res.message);
        return Promise.reject(res);
    }

    // 如果是未知错误，则统一弹出“请求失败！”
    message.error('请求失败！');
    return Promise.reject();
}

/**
 * POST 请求
 * @param {String} url 请求地址
 * @param {*} data 请求体
 * @param {Object} others 其他参数
 */
export function post(url, data, others = {}) {
    return instance({
        method: 'post',
        baseURL: baseURL,
        url,
        data: data,
        timeout: others.unlimitedTime ? 0 : 10000,
        emulateJSON: true,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8'
        },
        ...others
    }).then(
        (res) => {
            return checkStatus(res);
        },
        (err) => {
            return checkStatus(err);
        }
    );
}

/**
 * GET 请求
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function get(url, params) {
    return instance({
        method: 'get',
        baseURL: baseURL,
        url,
        params, // get 请求时带的参数
        timeout: 10000,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(
        (res) => {
            return checkStatus(res);
        },
        (err) => {
            return checkStatus(err);
        }
    );
}
